var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndExpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 947,
    height: 504,
    viewBox: "0 0 947 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 51,
    width: 458,
    height: 453,
    rx: 75,
    fill: "url(#paint0_linear_2_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.667 10C617.524 10 604.919 13.8046 595.626 20.5767C586.332 27.3489 581.111 36.5338 581.111 46.1111V262.778L482 335H878.444C891.587 335 904.192 331.195 913.486 324.423C922.779 317.651 928 308.466 928 298.889V46.1111C928 36.5338 922.779 27.3489 913.486 20.5767C904.192 13.8046 891.587 10 878.444 10H630.667Z",
    stroke: "url(#paint1_linear_2_91)",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 113H831.191H842",
    stroke: "url(#paint2_linear_2_91)",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 174L808.578 174L818 174",
    stroke: "url(#paint3_linear_2_91)",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 234L778.428 234L786 234",
    stroke: "url(#paint4_linear_2_91)",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 75C0 33.5787 33.5786 0 75 0H383.002C424.423 0 458.002 33.5786 458.002 75V378.037C458.002 419.459 424.423 453.037 383.002 453.037H327.515V422.116C327.515 394.568 318.364 367.591 301.278 347.226C284.104 326.757 259.981 314.385 233.908 314.385H86.6931C60.6205 314.385 36.497 326.757 19.3232 347.226C10.9515 357.204 4.48471 368.769 0.065957 381.212C0.0221308 380.159 0 379.101 0 378.037V75ZM287.515 422.116V453.037H75C59.4751 453.037 45.052 448.32 33.0857 440.241V422.116C33.0857 403.128 39.4447 385.476 49.9663 372.936C60.4008 360.499 73.7219 354.385 86.6931 354.385H233.908C246.879 354.385 260.2 360.499 270.635 372.936C281.156 385.476 287.515 403.128 287.515 422.116ZM107.238 203.327C107.238 174.366 131.033 150.518 160.846 150.518C190.658 150.518 214.453 174.366 214.453 203.327C214.453 232.288 190.658 256.137 160.846 256.137C131.033 256.137 107.238 232.288 107.238 203.327ZM160.846 110.518C109.354 110.518 67.2384 151.865 67.2384 203.327C67.2384 254.79 109.354 296.137 160.846 296.137C212.338 296.137 254.453 254.79 254.453 203.327C254.453 151.865 212.338 110.518 160.846 110.518Z",
    fill: "url(#paint5_linear_2_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.349 30.2833C344.455 23.8583 353.545 23.8583 355.651 30.2834L371.892 79.8074C372.835 82.6823 375.518 84.6262 378.543 84.6262H430.96C437.757 84.6262 440.566 93.3363 435.05 97.3072L392.755 127.754C390.279 129.537 389.243 132.717 390.193 135.616L406.374 184.96C408.486 191.398 401.132 196.781 395.633 192.823L353.09 162.196C350.647 160.438 347.353 160.438 344.91 162.196L302.367 192.823C296.868 196.781 289.514 191.398 291.626 184.96L307.807 135.616C308.757 132.717 307.721 129.537 305.245 127.754L262.95 97.3072C257.434 93.3363 260.243 84.6262 267.04 84.6262H319.457C322.482 84.6262 325.165 82.6823 326.108 79.8074L342.349 30.2833Z",
    fill: "#FFB33B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_91",
    x1: 46,
    y1: 51,
    x2: 498.973,
    y2: 508.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB01FF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F06",
    stopOpacity: 0.73
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_91",
    x1: 928,
    y1: 172.5,
    x2: 482,
    y2: 172.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_91",
    x1: 748.5,
    y1: 113,
    x2: 748.5,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_91",
    x1: 736.5,
    y1: 174,
    x2: 736.5,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_91",
    x1: 720.5,
    y1: 234,
    x2: 720.5,
    y2: 235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_91",
    x1: 0,
    y1: 0,
    x2: 453.01,
    y2: 457.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB01FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 504,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndExpLogo);
export default __webpack_public_path__ + "static/media/ind-exp-logo.6742cd81593ec12fde1410e193395187.svg";
export { ForwardRef as ReactComponent };